import { combineReducers } from "redux";
import { changeNumber } from "./UpdateOne";

const rootReducer = combineReducers({ changeNumber });
export default rootReducer;
